import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Typography } from '@mui/material';
import { InfoIcon } from '@sharedCR/coreDesignSystem/icons';
import { Wrapper } from 'app/shared/components/loanManagement/PrimaryDataWrapper';
import DOMPurify from 'dompurify';

import { selectSuspenseReason } from 'store/loanApplications/selectors';

import { UnderwritingTestIds } from '../../Underwriting.testIds';

const suspenseReasonsViewConfig = {
  name: 'Suspense Reason',
  icon: InfoIcon,
};

const SuspenseReason = () => {
  const suspenseReason = useSelector(selectSuspenseReason);

  const sanitizedSuspenseReason = useMemo(() => {
    const sanitizedHtml = DOMPurify.sanitize(suspenseReason, {
      WHOLE_DOCUMENT: true,
    });

    return { __html: sanitizedHtml };
  }, [suspenseReason]);

  return (
    <Wrapper
      config={suspenseReasonsViewConfig}
      dataTestId={UnderwritingTestIds.SUSPENSE_REASON_SECTION}
      isButtonsVisible={false}
    >
      <Typography dangerouslySetInnerHTML={sanitizedSuspenseReason} variant="regular14" />
    </Wrapper>
  );
};

export default memo(SuspenseReason);
